export const frQuote = {
  button: 'Demander un devis',
  clickHint: 'Devis',
  modalTitle: 'Demande de devis',
  modalSubtitle: 'pour',
  itemLabel: 'Service ou solution concerné (optionnel)',
  itemNone: 'Aucun — demande générale',
  itemServices: 'Services',
  itemSolutions: 'Solutions',
  name: 'Nom complet',
  email: 'Email',
  phone: 'Téléphone (optionnel)',
  message: 'Décrivez votre projet (optionnel)',
  messagePlaceholder: "Parlez-nous de vos besoins, délais, budget approximatif...",
  submit: 'Envoyer la demande',
  submitting: 'Envoi en cours...',
  cancel: 'Annuler',
  success: 'Votre demande a été envoyée ! Nous vous répondrons rapidement.',
  error: "Une erreur s'est produite. Veuillez réessayer ou nous contacter directement.",
  requiredField: 'Ce champ est requis',
  invalidEmail: 'Adresse email invalide',
};

export const enQuote = {
  button: 'Request a quote',
  clickHint: 'Quote',
  modalTitle: 'Quote request',
  modalSubtitle: 'for',
  itemLabel: 'Related service or solution (optional)',
  itemNone: 'None — general request',
  itemServices: 'Services',
  itemSolutions: 'Solutions',
  name: 'Full name',
  email: 'Email',
  phone: 'Phone (optional)',
  message: 'Describe your project (optional)',
  messagePlaceholder: 'Tell us about your needs, timeline, approximate budget...',
  submit: 'Send request',
  submitting: 'Sending...',
  cancel: 'Cancel',
  success: "Your request has been sent! We'll get back to you shortly.",
  error: 'Something went wrong. Please try again or contact us directly.',
  requiredField: 'This field is required',
  invalidEmail: 'Invalid email address',
};

export const nlQuote = {
  button: 'Offerte aanvragen',
  clickHint: 'Offerte',
  modalTitle: 'Offerteaanvraag',
  modalSubtitle: 'voor',
  itemLabel: 'Betreffende dienst of oplossing (optioneel)',
  itemNone: 'Geen — algemene aanvraag',
  itemServices: 'Diensten',
  itemSolutions: 'Oplossingen',
  name: 'Volledige naam',
  email: 'E-mail',
  phone: 'Telefoon (optioneel)',
  message: 'Beschrijf uw project (optioneel)',
  messagePlaceholder: 'Vertel ons over uw behoeften, tijdlijn, ongeveer budget...',
  submit: 'Aanvraag versturen',
  submitting: 'Verzenden...',
  cancel: 'Annuleren',
  success: 'Uw aanvraag is verzonden! We nemen spoedig contact met u op.',
  error: 'Er is iets misgegaan. Probeer het opnieuw of neem rechtstreeks contact met ons op.',
  requiredField: 'Dit veld is verplicht',
  invalidEmail: 'Ongeldig e-mailadres',
};

export const deQuote = {
  button: 'Angebot anfordern',
  clickHint: 'Angebot',
  modalTitle: 'Angebotsanfrage',
  modalSubtitle: 'für',
  itemLabel: 'Betreffender Service oder Lösung (optional)',
  itemNone: 'Keine — allgemeine Anfrage',
  itemServices: 'Services',
  itemSolutions: 'Lösungen',
  name: 'Vollständiger Name',
  email: 'E-Mail',
  phone: 'Telefon (optional)',
  message: 'Beschreiben Sie Ihr Projekt (optional)',
  messagePlaceholder: 'Erzählen Sie uns von Ihren Anforderungen, Zeitplan, ungefährem Budget...',
  submit: 'Anfrage senden',
  submitting: 'Wird gesendet...',
  cancel: 'Abbrechen',
  success: 'Ihre Anfrage wurde gesendet! Wir melden uns in Kürze bei Ihnen.',
  error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.',
  requiredField: 'Dieses Feld ist erforderlich',
  invalidEmail: 'Ungültige E-Mail-Adresse',
};
